import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorMasterSubdistrictSearch = () => {
  const subdistrictSearch = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/management/master-subdistrict/search', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])

  return { subdistrictSearch }
}

export default InteractorMasterSubdistrictSearch
